/**
 * Proveedores GraphQL Queries
 * Ajusta las consultas GraphQL relacionadas con proveedores aquí.
 */

/** Campos por defecto para proveedores ADMIN */
export const DEFAULT_ADMIN_PROVIDER_FIELDS = [
	'id',
	'nombreProveedor',
	'numRUC',
	'razonSocial',
];

/** Campos por defecto para proveedores SOURCING */
export const DEFAULT_SOURCING_PROVIDER_FIELDS = [
	'id',
	'nombre',
	'estadoProveedor',
	'razonSocial',
	'numRUC',
];

/**
 * Campos por defecto para proveedores A&B.
 * - Estos corresponden al resolver solicitado por backend para getAllProvider.
 */
export const DEFAULT_AYB_PROVIDER_FIELDS = [
	'id',
	'codigoProveedor',
	'cuentaContableDolares',
	'cuentaContableSoles',
	'direccionSocial',
	'distrito',
	'documento',
	'nombreComercial',
	'provincia',
	'razonSocial',
	'ruc',
	'telefono',
];

/** BUILDS QUERIES BASICAS */
export const buildGetAllAdminProviderQuery = (fields: string): string => `
	query GetAllProvider {
		getAllProvider {
${fields}
		}
	}
`;

export const buildGetAllSourcingProviderQuery = (fields: string): string => `
	query GetAllProvider {
 		getAllProvider {
 ${fields}
 		}
	}
`;

export const buildGetAllAyBProviderQuery = (fields: string): string => `
	query GetAllProvider {
		getAllProvider {
${fields}
		}
	}
`;

/** BUILDS QUERIES CON PROYECCION */
export const buildGetAllSourcingWithProjectionQuery = (fields: string): string => `
	query getAllProvidersWithProjectionExpression($projectionExpression: String, $includeDisabled: Boolean) {
		getAllProvidersWithProjectionExpression(projectionExpression: $projectionExpression, includeDisabled: $includeDisabled) {
${fields}
		}
	}
`;

/** QUERIES PARA SOURCING */

export const queryGetAllProviderSourcing = `
	query{
        getAllProvider{
          id,
          nombre,
          condicionesPagos{
            condicionPago,
            plazoDiasFit,
            plazoDiasGrupos,
            plazoDiasSeries
          },
          estadoProveedor,
          razonSocial,
          cuentaCorrienteSoles,
          cuentaCorrienteDolares,
          saldoSoles,
          saldoDolares,
          listSAF{
            id,
            codigo,
            fileNumber,
            os,
            monto,
            moneda,
            usuario,
            createdAt
          },
          numRUC,
          numDNI,
          tipoPersona,
          direccionLegal,
          pais,
          ubicacionOperativa,
          observaciones{
            tituloObservacion,
            textoObservacion
          },
          contactos{
            contactoNombre,
            contactoCargo,
            contactoCorreo,
            contactoCelular,
            contactoTelefono,
            contactoTelefonoAnexo
          },
          tipoProveedor
        }
      }
`;

export const queryGetProviderSourcingById = `
	query getProvider($id: String!) {
		getProvider(id: $id) {
			id
			nombre
			estadoProveedor
			razonSocial
			numRUC
			numDNI
			tipoPersona
			direccionLegal
			pais
			ubicacionOperativa
			observaciones {
				tituloObservacion
				textoObservacion
			}
			contactos {
				contactoNombre
				contactoCargo
				contactoCorreo
				contactoCelular
				contactoTelefono
				contactoTelefonoAnexo
			}
		}
	}
`;

export const queryGetProviderSourcingByName = `
	query getProviderByName($name: String!) {
		getProviderByName(name: $name) {
			id
			nombre
			estadoProveedor
			razonSocial
			numRUC
			numDNI
			tipoPersona
			direccionLegal
			pais
			ubicacionOperativa
			cuentaCorrienteDolares
			saldoDolares
			cuentaCorrienteSoles
			saldoSoles
			observaciones {
				tituloObservacion
				textoObservacion
			}
			contactos {
				contactoNombre
				contactoCargo
				contactoCorreo
				contactoCelular
				contactoTelefono
				contactoTelefonoAnexo
			}
		}
	}
`;

/** QUERIES PARA A&B */

/** QUERIES PARA ADMIN */

export const queryGetAllProviderAdmin = `
	query{
        getAllProvider{
			id,
			cuentaCorriente,
			cuentaCorrienteSoles,
			cuentaCorrienteDolares,
			saldoSoles,
			saldoDolares,
			numRUC,
			nombreProveedor,
			dni,
			razonSocial,
			condicion,
			tipoPersona,
			estadoProveedor,
			direccion,
			urbanizacion,
			distrito,
			provincia,
			departamento,
			pais,
			ubigeo,
			observaciones{
				titulo,
				observacion
			},
			contactos{
				nombre,
				cargo,
				correo,
				celular,
				telefono,
				telefonoAnexo
			},
			cuentas{
				banco,
				moneda,
				numero,
				cci,
				observacionCuenta,
				favorito
			}
        }
    }
`;

export const queryGetProviderAdminById = `
	query getProvider($id:String!){
        getProvider(id:$id){
			id,
			cuentaCorriente,
			numRUC,
			nombreProveedor,
			dni,
			razonSocial,
			condicion,
			tipoPersona,
			estadoProveedor,
			direccion,
			urbanizacion,
			distrito,
			provincia,
			departamento,
			pais,
			ubigeo,
			observaciones{
				titulo,
				observacion
			},
			contactos{
				nombre,
				cargo,
				correo,
				celular,
				telefono,
				telefonoAnexo
			},
			cuentas{
				banco,
				moneda,
				numero,
				cci,
				observacionCuenta,
				favorito
			}
        }
    }
`;